import React, { FC, Fragment } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  IconButton,
  Typography,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Tooltip,
  Badge,
  Button,
  CircularProgress
} from '@material-ui/core';
import { RED, GREEN } from 'constants/colors';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom, StatusPayment, TableRowCollapse } from 'components';
import { format } from 'date-fns';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import NumberFormat from 'components/NumberFormat';
import Skeleton from '@material-ui/lab/Skeleton';
import ErrorIcon from '@material-ui/icons/Error';
import TimerOffTwoToneIcon from '@material-ui/icons/TimerOffTwoTone';
import clx from 'clsx';
import PrintRequest from 'images/icon/PrintIndicator1.png';
import PrintAccept from 'images/icon/PrintIndicator2.png';
import HasPrint from 'images/icon/PrintIndicator3.png';
import { DeleteOutline, EditOutlined } from '@material-ui/icons';
import GetAppIcon from '@material-ui/icons/GetApp';

interface Props {
  invoicesMovement: InvoiceMovementModel;
  isLoading: boolean;
  onDelete: React.MouseEventHandler;
  onUpdate: (id: number) => void;

  // onDownload: React.MouseEventHandler;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    deleteButton: {
      color: RED,
      width: 30
    },
    tableCellAction: {
      width: 30
    },
    tableCellPrint: {
      width: 100
    },
    tableCellPrint1: {
      width: 200
    },
    customerName: {
      fontSize: '15px',
      fontWeight: 500,
      fontFamily: 'Rubik',
      fontStyle: 'normal',
      lineHeight: '22px'
    },
    tableCollapse: {
      width: '100%'
    },
    cellCollapse: {
      border: 'none'
    },
    requestEdit: {
      backgroundColor: GREEN,
      padding: 4
    },
    rowRequestEdited: {
      backgroundColor: '#ccc',
      '&:hover': {
        backgroundColor: '#ccc'
      }
    },
    rowNewEdited: {
      boxShadow: '0px 2px 4px rgba(0, 136, 186, 0.4)',
      borderRadius: 4
    },
    tableCell: {
      width: 100
    },
    timeOut: {
      animation: 'shake 0.5s',
      animationIterationCount: 'infinite'
    },
    '@keyframes shake': {
      '0%': { transform: 'translate(1px, 1px) rotate(0deg)' },
      '10%': { transform: ' translate(-1px, -2px) rotate(-1deg)' },
      '20%': { transform: ' translate(-3px, 0px) rotate(1deg)' },
      '30%': { transform: ' translate(3px, 2px) rotate(0deg)' },
      '40%': { transform: ' translate(1px, -1px) rotate(1deg)' },
      '50%': { transform: ' translate(-1px, 2px) rotate(-1deg)' },
      '60%': { transform: ' translate(-3px, 1px) rotate(0deg)' },
      '70%': { transform: ' translate(3px, 1px) rotate(-1deg)' },
      '80%': { transform: ' translate(-1px, -1px) rotate(1deg)' },
      '90%': { transform: ' translate(1px, 2px) rotate(0deg)' },
      '100%': { transform: ' translate(1px, -2px) rotate(-1deg)' }
    }
  })
);

const BodyRow: FC<Props> = props => {
  const { invoicesMovement, isLoading, onDelete, onUpdate } = props;

  console.log('');

  const classes = useStyles();

  return (
    <Fragment>
      <TableRowCustom>
        <TableCellStart>{isLoading ? <Skeleton variant='text' width={'100%'} height={25} /> : invoicesMovement.name}</TableCellStart>
        <TableCellMiddle align='center'>
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={25} />
          ) : invoicesMovement.date ? (
            format(new Date(invoicesMovement.date), 'dd MMM yyyy')
          ) : null}
        </TableCellMiddle>
        <TableCellEnd align='right'>
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={25} />
          ) : (
            <>
              <Tooltip title='Hapus Route'>
                <IconButton size='small' onClick={onDelete}>
                  <DeleteOutline fontSize='small' />
                </IconButton>
              </Tooltip>
              <Tooltip title='Cetak laporan '>
                <IconButton size='small' onClick={() => onUpdate(invoicesMovement.id)}>
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </TableCellEnd>
      </TableRowCustom>
    </Fragment>
  );
};

export default BodyRow;
